<template>
  <div id="app">
    <notifications group="gst" position="top right">
      <template slot="body" slot-scope="props">
        <div :class="`custom-notification ${props.item.type}`">
          <a class="title">
            {{props.item.title}}
          </a>
          <a class="close" @click="props.close">
            <v-icon>cancel</v-icon>
          </a>
          <div v-html="props.item.text"></div>
        </div>
      </template>
    </notifications>
    <component :is="layout">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </component>
  </div>
</template>
<script>
const defaultLayout = 'default'
export default {
  name: 'App',
  data: () => ({
    title: 'Intekel',
    drawer: false,
    userLogged: {
      roles: [
        {
          permissions: ''
        }
      ]
    },
    menu: false,
    show: true
  }),
  methods: {
    toRoute (route) {
      this.$router.push(route)
    },
    setLogin () {
      return true
    }
  },
  beforeCreate () {
    if (this.$store.state.userState === undefined) {
      this.$store.dispatch('userLogged', { event: { context: this } })
    }
  },
  watch: {
    $route (to, from) {
      this.$notify({group: 'gst', clear: true})
    }
  },
  computed: {
    layout () {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    },
    login () {
      return this.$store.state.loginState
    }
  }
}
</script>

<style lang="scss">
@import 'assets/base.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue